import { Component, Vue } from 'vue-property-decorator';
import { Breadcrumbs, Breadcrumb } from '../types';

@Component
export default class BreadcrumbsMixin extends Vue {
  public breadcrumbsLead: Breadcrumbs = [
    {
      text: 'Главная',
      to: { path: '/' },
    },
  ];

  public routeName = 'search';

  get breadcrumbs() {
    const list: Breadcrumbs = [...this.breadcrumbsLead];
    if (this.$options.breadcrumbsLead)
      list.push(...this.$options.breadcrumbsLead);
    if (this.queryRoute) {
      list.push(this.queryRoute);
    } else {
      const blank = {
        text: 'Поиск',
        to: { name: 'global-search' },
      };
      list.push(blank);
    }
    return list;
  }

  get queryRoute(): Breadcrumb | null {
    const { routeName, $route } = this;
    const { term } = $route.query;
    if (!term) return null;

    return {
      text: term,
      to: {
        name: routeName,
        query: {
          term,
        },
      },
    };
  }
}



// WEBPACK FOOTER //
// ./src/pages/global-search/mixins/breadcrumbs-mixin.ts